import { render, staticRenderFns } from "./ChatPrincipal.vue?vue&type=template&id=14478b6c"
import script from "./ChatPrincipal.vue?vue&type=script&lang=js"
export * from "./ChatPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports